import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { Observable } from 'rxjs';
import { CheckoutFormModel } from '../model/checkout-forms.model';
import { PlaceOrderUsingCheckoutForm, UpdateCheckoutForm } from '../store/actions/checkout-forms.action';
import { CHECKOUT_FORM, StateWithCheckoutForm } from '../store/checkout-forms.state';
@Injectable()
export class CheckoutFormService {
  checkoutForms: Observable<CheckoutFormModel>;
  checkoutStore: any;

  // tslint:disable-next-line: deprecation
  constructor(protected checkoutFormStore: Store<StateWithCheckoutForm>, protected cartData: ActiveCartFacade) {
    this.checkoutForms = checkoutFormStore.pipe(select(CHECKOUT_FORM));
  }

  updateCheckoutForm(formsObjectValue: any): void {
    this.checkoutFormStore.dispatch(
      new UpdateCheckoutForm({
        formsObjectValue,
      })
    );
  }

  placeOrder(): void {
    // need to revise for action allowed
    // if (this.actionAllowed()) {
    this.checkoutFormStore.dispatch(new PlaceOrderUsingCheckoutForm());
    // }
  }

  protected actionAllowed(): Observable<boolean> {
    // to check later for userId
    // return this.cartData.userId !== OCC_USER_ID_ANONYMOUS || this.cartData.isGuestCart();
    return this.cartData.isGuestCart();
  }
}
